import {useQuery} from 'react-query';
import {getBankAccountInfo} from './getBankAccountInfo';

const useGetBankAccountInfo = (enabled = true) => {
  return useQuery(['get-bank-account-info'], getBankAccountInfo, {
    enabled,
  });
};
export default useGetBankAccountInfo;
